// Generated file - do not change manually!
/**
 * Defines the <code>Title</code> level
 */
export var TitleLevel;
(function (TitleLevel) {
    /**
     * Renders <code>h1</code> tag.
     */
    TitleLevel["H1"] = "H1";
    /**
     * Renders <code>h2</code> tag.
     */
    TitleLevel["H2"] = "H2";
    /**
     * Renders <code>h3</code> tag.
     */
    TitleLevel["H3"] = "H3";
    /**
     * Renders <code>h4</code> tag.
     */
    TitleLevel["H4"] = "H4";
    /**
     * Renders <code>h5</code> tag.
     */
    TitleLevel["H5"] = "H5";
    /**
     * Renders <code>h6</code> tag.
     */
    TitleLevel["H6"] = "H6";
})(TitleLevel || (TitleLevel = {}));
